export const getMIMEBodyTemplate = (mailId: string) =>
  `<GetItem
    xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"
  >
    <ItemShape>
      <t:BaseShape>Default</t:BaseShape>
      <t:IncludeMimeContent>true</t:IncludeMimeContent>
    </ItemShape>
    <ItemIds>
      <t:ItemId Id="${mailId}" />
    </ItemIds>
  </GetItem>
`;
